// extracted by mini-css-extract-plugin
export default {"header":"Header-Header-header-d22bf2a7","close":"Header-Header-close-1ea33978"};